// --- Categories ---
const speedCategories = {
  20: {
    color: '#310000',
    border: '#140000',
    category: 'Velocidad muy baja',
  },
  30: {
    color: '#FF0000',
    border: '#500000',
    category: 'Velocidad baja',
  },
  40: {
    color: '#FF5500',
    border: '#732600',
    category: 'Velocidad en frentes',
  },
  50: {
    color: '#FFAA00',
    border: '#734C00',
    category: 'Velocidad media',
  },
  60: {
    color: '#AAFF00',
    border: '#4C7300',
    category: 'Velocidad alta',
  },
  80: {
    color: '#00FFC5',
    border: '#00734C',
    category: 'Velocidad muy alta',
  },
  100: {
    color: '#0070FF',
    border: '#002673',
    category: 'Velocidad fuera de talabre',
  },
  150: {
    color: '#FF00C5',
    border: '#73004C',
    category: 'Sin limite de velocidad',
  },
};

// --- Function to get the category ---
const getGeofenceCategory = speedLimitUp => {
  const categoryData = speedCategories[speedLimitUp];

  if (categoryData) {
    return {
      category: categoryData.category,
      fill: categoryData.color,
      border: categoryData.border,
    };
  } else {
    // Fallback if speedLimitUp not found
    return {
      category: 'Velocidad desconocida',
      fill: '#14b7ee',
      border: '#FFF',
    };
  }
};

export { getGeofenceCategory };
